import { render, staticRenderFns } from "./TextFieldTegaki.vue?vue&type=template&id=74444878&scoped=true&lang=pug"
import script from "./TextFieldTegaki.vue?vue&type=script&lang=ts"
export * from "./TextFieldTegaki.vue?vue&type=script&lang=ts"
import style0 from "./TextFieldTegaki.vue?vue&type=style&index=0&id=74444878&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74444878",
  null
  
)

export default component.exports